export const LOGO_BLACK =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sound-branding-pro/artifacts/mnssfpuu_akkasmusic%20logo%20black.webp";
export const LOGO_GREY =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sound-branding-pro/artifacts/6lpprq0y_akkasmusic%20logo%20grey.webp";
export const LOGO_WHITE =
  "https://customer-assets-39nsmqrw.emergentagent.net/job_sound-branding-pro/artifacts/fnsk7s8m_akkasmusic%20logo%20white.webp";
export const PORTRAIT =
  "https://customer-assets-eiarnc6j.emergentagent.net/job_e4eb697b-6d75-4cf6-8d16-91c0b692b8ad/artifacts/w9ii0d5e_B77A8099-5E97-41CF-B07E-BF172E68689A.webp";
